import { InteractionType } from "@/common/types";

export enum HistoryInteractionTypes {
	Call = 0,
	Callback = 1,
	Voicemail = 2,
	Email = 3,
	Generic = 4,
	WhatsApp = 5,
	Webchat = 6,
}

export interface GetHistoryRequest {
    pageSize: number;

	pageNumber: number;

	sortBy?: string;

	filter?: string;

    queueIds?: string[];

	supervisedOrOperatedQueueIds?: string[];

    types?: InteractionType[];

	isHandled?: boolean;

	isOutbound?: boolean;

	isInbound?: boolean;

	isCallback?: boolean;

	isTransferred?: boolean;

	isMissed?: boolean;

	isSupervisorOrOperator?: boolean;

	showMyInteractions?: boolean;
}